import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createWorkflowCard } from "src/business/workflow/apiWorkflow";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { CatalogRecordForm } from "src/pages/catalogs/CatalogRecordForm";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { createWfNewRecordStore, WfNewRecordStore } from "./wfNewRecordStore";
import { WorkflowPageTitle } from "./WorkflowPageTitle";

export const WfNewRecordPage: React.FC = observer(() => {
  const { id: catalogId = "", workflowId = "" } = useParams();
  const pageStore = React.useMemo(() => {
    const store = createWfNewRecordStore();
    store.init(catalogId, workflowId);
    return store;
  }, [catalogId, workflowId]);

  return (
    <PageLayout title={pageStore.breadcrumbs}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={() => <Inner pageStore={pageStore} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ pageStore: WfNewRecordStore }> = observer(
  ({ pageStore }) => {
    const navigate = useNavigate();
    if (!pageStore.cdsFormStore) return null;
    return (
      <CatalogRecordForm
        title={
          <WorkflowPageTitle
            title="Новая рабочая версия"
            stepName={pageStore.currentStepName}
            stepDescription={pageStore.currentStepDescription}
          />
        }
        okText="Создать"
        store={pageStore.cdsFormStore}
        submit={(values) =>
          createWorkflowCard(pageStore.catalogId, pageStore.workflowId, values)
        }
        onSuccess={({ id }) => {
          msgQueueStore.add({
            type: "success",
            message: "Создана новая запись",
          });
          navigate(makeUrl(PageUrl.editRecordWf, { id }), { replace: true });
        }}
      />
    );
  },
);
